import * as React from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateStateData } from "../../../../Store/actions";
import MultiSelect from "../../../../components/commonComponents/Selectors/MultiSelect";

export default function Regions({ redux_param_name, reduxKeywordToSaveValue, filterParamNielsenRegionCode,
    nielsenRegionFilterEnabled }) {
    const userStateData = useSelector((state) => state.userSelections);
    const dispatchAction = useDispatch();
    const [changesMade, setChangesMade] = React.useState(false);
    const [dataLoaded, setDataLoaded] = React.useState(false);
    const [selectedRegionFromDropdown, setSelectedRegionFromDropdown] = React.useState([]);
    const [selectedRegionNameForEmbeddable, setSelectedRegionNameForEmbeddable] = React.useState([]);

    // const nielsenRegionsSelected = typeof userStateData[reduxKeywordToSaveValue] !== "undefined" && typeof userStateData[reduxKeywordToSaveValue][filterParamNielsenRegionCode] !== "undefined" ? userStateData[reduxKeywordToSaveValue][filterParamNielsenRegionCode] : [];

    // dropdown options (nielsen filter applied if applicable)
    let regionNames = React.useMemo(() => {
        return typeof userStateData.campaign_regions !== "undefined" && userStateData.campaign_regions.length !== 0 ?
            userStateData.campaign_regions
            : []

    }, [userStateData?.campaign_regions]);

    // let regionNames = React.useMemo(() => {
    //     return typeof userStateData.campaign_regions !== "undefined" && userStateData.campaign_regions.length !== 0 ? nielsenRegionFilterEnabled === true && nielsenRegionsSelected.length !== 0 ?
    //         userStateData.campaign_regions.filter(region => {
    //             return nielsenRegionsSelected.includes(region.nielsen_code)
    //         })
    //         :
    //         userStateData.campaign_regions
    //         :
    //         []
    // }, [userStateData?.[reduxKeywordToSaveValue]?.[filterParamNielsenRegionCode]]);

    React.useEffect(() => {
        setSelectedRegionNameForEmbeddable(regionNames);

        // selected values for regions
        const selectedValues = typeof userStateData[reduxKeywordToSaveValue] !== "undefined" && typeof userStateData[reduxKeywordToSaveValue][redux_param_name] !== "undefined" ? userStateData[reduxKeywordToSaveValue][redux_param_name] : regionNames

        if (selectedValues.length !== 0) {
            setSelectedRegionFromDropdown(
                selectedValues.map((regionName) => {
                    return { value: regionName, label: regionName };
                })
            );
        }

        setDataLoaded(true);
    }, [userStateData?.[reduxKeywordToSaveValue]?.[redux_param_name]]);

    return dataLoaded ? (
        <MultiSelect
            enableFullWidth={true}
            label={"Region"}
            options={regionNames}
            defaultVal={selectedRegionFromDropdown}
            selectionCheck={(option, value) => option.label === value.label}
            usedFor="regionsFilter"
            onChangeCall={(selectedOption) => {
                let userChoices = [];
                selectedOption.forEach((chosen) => {
                    if (chosen.label !== "(All)") {
                        userChoices.push(chosen.label);
                    } else {
                        userChoices.push([...new Set(regionNames)]);
                    }
                });
                setSelectedRegionNameForEmbeddable(userChoices);
                setSelectedRegionFromDropdown(selectedOption);
                setChangesMade(true);
            }}
            onBlurCall={(e) => {
                if (selectedRegionNameForEmbeddable.length !== 0 && changesMade === true) {
                    let regionSelections = selectedRegionNameForEmbeddable;
                    dispatchAction(
                        updateStateData({
                            [reduxKeywordToSaveValue]: {
                                ...userStateData[reduxKeywordToSaveValue],
                                [redux_param_name]: regionSelections,
                            }
                        })
                    );
                    setChangesMade(false);
                }
            }}
        />
    ) : (
        <></>
    );
}
